import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import sections from 'web-assets/images/sections.png';

import secureLock from 'web-assets/images/icons/secure-lock.svg';
import privacyProtect from 'web-assets/images/icons/privacy-protect-shield.svg';
import encryptionKey from 'web-assets/images/icons/encryption-key.svg';

export const MainContainer = styled(Flex).attrs({
  column: true,
  width: '100%',
})`
  background: ${props => props.theme.colors.primary};
`;

export const MiddleContainer = styled(Flex).attrs({
  column: true,
})`
  margin: 0 auto;
  width: calc(100% - 40px);
  max-width: 960px;
`;

export const CheckoutMiddleContainer = styled(MiddleContainer)`
  background: #ffffff;
  border-radius: 5px;
  padding-bottom: 4px;
  position: relative;
  z-index: 3;
`;

export const Wrapper = styled(Flex)`
  width: 100%;
  background: #000000;

  img {
    max-width: 100%;
  }
`;
export const CheckoutContainer = styled(Flex).attrs({
  column: true,
})`
  width: 100%;
  margin-top: -261px;
`;

export const AboutProduct = styled(Flex).attrs({
  align: 'center',
})`
  width: 100%;
  border-radius: 4px 4px 0 0;
  min-height: 261px;
  border-bottom: 1px solid #e4e4e4;
  background: #f7f7f7;
  position: relative;
  z-index: 5;
  overflow: hidden;

  @media (max-width: 767px) {
    flex-direction: column;

    hgroup {
      margin-bottom: 15px;
    }
  }
`;

export const ProdctImage = styled(Flex)`
  width: 500px;

  @media (min-width: 768px) {
    margin-left: -100px;
  }

  img {
    max-width: 100%;
  }
`;

export const FormContainer = styled(Flex)`
  width: 100%;
  background: #fff;

  @media (max-width: 767px) {
    flex-direction: column-reverse;

    & > div {
      width: 100% !important;
    }
  }
`;

export const SubTitle = styled(Flex).attrs({
  column: true,
})`
  width: 100%;
  padding: 0 0 23px;
  margin: 15px 15px 0 0;
`;

export const Form = styled(Flex).attrs({
  as: 'form',
})`
  width: 100%;
  padding: 0 30px 10px;

  @media (min-width: 500px) {
    .card-expiry > span {
      width: 230px;
    }

    .card-cvc > span {
      width: 150px;
    }
  }
`;

export const SubmitButton = styled(Button).attrs({
  type: 'submit',
  appearance: 'success',
})`
  color: #fff;
  font-size: 18px;
  height: auto;
  padding: 10px 25px;
  border-radius: 5px;
  width: 100%;
  line-height: 24px;
`;

export const Location = styled(Flex).attrs({
  width: '100%',
})`
  flex-direction: column;

  & > *:not(:first-child) {
    margin-top: 15px;
  }

  @media (min-width: 992px) {
    flex-direction: row;

    & > *:not(:first-child) {
      width: 150px;
      margin-top: 0px;
      margin-left: 30px;
    }
  }
`;

export const WhatsInside = styled(Flex).attrs({
  column: true,
  spacing: 15,
})`
  min-height: 193px;
  background: #fffbbd;
  padding: 45px 30px;
  flex-shrink: 0;

  @media (min-width: 768px) {
    width: 390px;
  }

  h3 {
    margin-top: 0;
    text-align: center;
  }
`;

export const ThreeSections = styled(Flex)`
  height: 185px;
  background-image: url(${sections});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 0 -8px;
  flex-shrink: 0;


  .symbol01,
  .symbol02,
  .symbol03 {
    width: 65px;
    height: 66px;
    display: block;
  }

  .symbol01 {
    background: url(${secureLock}) no-repeat;
  }

  .symbol02 {
    background: url(${privacyProtect}) no-repeat;
  }

  .symbol03 {
    background: url(${encryptionKey}) no-repeat;
  }

  p {
    color: #999;
    font-size: 12px;
    text-align: center;
    line-height: 18px;
    margin: 0;
  }

  @media (min-width: 440px) {
    background-size: cover;
  }

  @media (min-width: 768px) {
    &.desktop {
      width: 390px;
      display: flex;
    }

    &.mobile {
      display: none;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    &.desktop {
      display: none;
    }
  }
`;
